(function () {
  if (!window.location.pathname.includes("/apps/bundles")) return;

  function parseMoney(text) {
    if (!text) return null;
    const m = text.replace(/,/g, "").match(/(\d+(\.\d{1,2})?)/);
    if (!m) return null;
    const val = parseFloat(m[1]);
    return Number.isFinite(val) ? val : null;
  }

  function symbolFrom(text) {
    const m = (text || "").match(/[$€£]/);
    return m ? m[0] : "$";
  }

  function enhance() {
    document.querySelectorAll(".ab-product-list-item").forEach((item) => {
      // Already added?
      if (item.querySelector(".ab-was-now")) return;

      const btnContent = item.querySelector(".ab-add-to-bundle-button-content");
      const btn = btnContent ? btnContent.closest("button") : null;
      if (!btn || !btnContent) return;

      // Use the displayed price (MSRP) as "was"
      const btnText = (btnContent.textContent || "").trim();
      const was = parseMoney(btnText);
      if (!was) return;

      const sym = symbolFrom(btnText);
      const now = was * 0.5;

      const row = document.createElement("div");
      row.className = "ab-was-now";
      row.innerHTML =
        '<span class="ab-was">' + sym + was.toFixed(2) + "</span>" +
        '<span class="ab-now">' + sym + now.toFixed(2) + "</span>" +
        '<span class="ab-off">50% OFF</span>';

      const parent = btn.parentNode;
      if (!parent) return;

      // 🔥 IMPORTANT: do NOT wrap/move the button. Only insert ABOVE it.
      parent.insertBefore(row, btn);

      // Add a hook class for CSS layout control
      parent.classList.add("ab-action-wrap");
    });
  }

  enhance();
  const obs = new MutationObserver(enhance);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();